import { useSelector } from 'react-redux';

export const optionsRadio = [
  [
    {
      name: 'motiveClient',
      value: 'El producto no funciona',
    },
    {
      name: 'motiveClient',
      value: 'El producto llegó roto',
    },
    {
      name: 'motiveClient',
      value: 'Aparecieron inconvenientes después del uso',
    },
  ],
];

export const MakeFields = () => {
  const { rut, orderId, sku, cud } = useSelector((state) => state.issuesSlice);

  return [
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'orderId',
      label: 'Oc',
      disabled: true,
      required: true,
      value: orderId,
      hidden: true,
    },
    {
      name: 'motiveClient',
      inputType: 'radio',
      disabled: true,
      required: true,
      hidden: true,
    },
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      disabled: true,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
      value: rut,
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      disabled: false,
      required: true,
    },
    {
      name: 'comment',
      multiline: true,
      rows: 4,
      inputAdornment: '',
      label: 'Escribir comentario',
      textArea: 'Escribir comentario',
      disabled: false,
      required: false,
      helper: '',
    },
  ];
};
